module.exports = __webpack_public_path__ + "static/media/doggo-2.eb48b73a.jpeg";